import React, { createContext, useContext, useState, useEffect } from 'react';

const Ctx = createContext({});

export const LANGS = {
  ru: {
    brand: 'Система оценки выпускных работ',
    heroTitle: 'Проверка дипломной работы',
    heroSub: 'Загрузите файл DOCX или PDF — система автоматически оценит соответствие требованиям',
    uploadTitle: 'Загрузите дипломную работу',
    uploadDrag: 'Отпустите файл',
    uploadHint: 'PDF или DOCX · до 50 МБ · перетащите или нажмите',
    uploadMaxSize: 'до 50 МБ',
    uploadedLabel: 'Документ загружен',
    replace: 'Заменить',
    analyzing: 'Анализируем работу...',
    analyzingStatus: 'Анализ...',
    ready: 'Готово',
    fileTypeError: 'Только PDF или DOCX',
    loadSteps: ['Загрузка файла', 'Анализ форматирования', 'Проверка структуры', 'Оценка библиографии', 'Расчёт итогового балла'],
    progressLabel: 'Прогресс анализа',
    totalScore: 'Итоговый балл',
    compliance: 'Соответствия',
    catFont: 'Форматирование',
    catVol: 'Объём',
    catStruct: 'Структура',
    catAnalysis: 'Экспертный анализ работы',
    catBib: 'Библиография',
    guideTitle: 'Критерии оценки ВКР',
    guideSub: 'Максимум 100 баллов',
    guideFootnote: 'Бонусные баллы (Глава 4) добавляются сверх базовых 81 балла',
    infoToggleShow: 'Что проверяется?',
    infoToggleHide: 'Скрыть описание',
    done: 'Выполнено',
    partial: 'Частично',
    notDone: 'Не выполнено',
    bonus: 'бонус',
    bonusDone: 'Бонус получен',
    bonusNone: 'Не найдено',
    details: 'подробнее',
    grades: ['ОТЛИЧНО', 'ХОРОШО', 'УДОВЛ.', 'НЕУДОВЛ.'],
    step1Label: 'Загрузите файл', step1Hint: 'PDF или DOCX',
    step2Label: 'Анализ',         step2Hint: '~15 секунд',
    step3Label: 'Результат',      step3Hint: 'Детальный отчёт',
    uploadBtn: 'Выбрать файл', uploadOrDrag: 'или перетащите сюда',
    footerLeft:  'Система проверки дипломных работ',
    footerContact: 'По вопросам сотрудничества:',
    footerCitation: 'Платформа описана в научной публикации:',
    legalPrivacyBtn: 'Политика конфиденциальности',
    legalTermsBtn: 'Условия использования',
    ptsSuffix: 'б',
    footerCitationLink: 'Alixonov Sh., Xashimov S. — ILMIY TADQIQOTLAR VA ULARNING YECHIMLARI JURNALI, 2026',

    // FeedbackCard
    feedbackTitle: 'Экспертный анализ работы',
    feedbackPros: 'Плюсы',
    feedbackCons: 'Минусы',
    feedbackTips: 'Советы по улучшению',
    feedbackNoPros: 'Нет явных преимуществ',
    feedbackNoCons: 'Замечаний нет — отличный результат!',
    scoreExcellent: '— Отличный уровень. Работа готова к защите.',
    scoreGood:      '— Хороший уровень. Исправьте замечания перед защитой.',
    scoreFair:      '— Удовлетворительный уровень. Требуются доработки.',
    scorePoor:      '— Требуются серьёзные доработки по большинству критериев.',

    // FeedbackCard — pros
    proFormatOk:      'Оформление текста полностью соответствует ГОСТ: Times New Roman 14 пт, интервал 1,5',
    proPageNums:      'Нумерация страниц расставлена корректно',
    proVolOk:         (p) => `Объём работы ${p} стр. — соответствует требованиям (≥45 стр.)`,
    proIntroOk:       'Введение полноценное — более 2 страниц',
    proConclusionOk:  'Заключение полноценное — более 2 страниц',
    proContentsOk:    'Оглавление с нумерацией страниц присутствует',
    proChaptersOk:    'Все три главы структурированы корректно (≥2 подраздела в каждой)',
    proConcSecOk:     'Раздел «Заключение» структурно выделен отдельным заголовком',
    proAppendixOk:    'Приложения включены в работу',
    proTablesOk:      'Анализ подкреплён таблицами и рисунками',
    proFindingsOk:    'В работе присутствуют выводы по главам',
    proCitationsOk:   'Текст подкреплён ссылками на источники',

    // FeedbackCard — cons
    conFontTimes:     'Шрифт не соответствует требованиям (требуется Times New Roman)',
    conFontSize:      'Размер шрифта не равен 14 пт',
    conLineSpacing:   'Межстрочный интервал не равен 1,5',
    conPageNums:      'Нумерация страниц не обнаружена',
    conVolLow:        (p) => `Объём работы ${p} стр. — недостаточен (требуется ≥45 стр.)`,
    conIntroShort:    'Введение короче нормы (требуется более 2 стр.)',
    conIntroMissing:  'Раздел «ВВЕДЕНИЕ» не обнаружен',
    conConcShort:     'Заключение короче нормы (требуется более 2 стр.)',
    conConcMissing:   'Раздел «ЗАКЛЮЧЕНИЕ» не обнаружен',
    conContents:      'Оглавление не обнаружено',
    conChapterSubs:   (n) => `Глава ${n} содержит менее 2 подразделов`,
    conChapterMiss:   (n) => `Глава ${n} не обнаружена в документе`,
    conAppendix:      'Раздел «Приложения» отсутствует',
    conTables:        'Недостаточно иллюстративного материала (таблицы, рисунки)',
    conFindings:      'Выводы по главам не обнаружены',
    conCitations:     'Мало ссылок на источники в тексте',

    // FeedbackCard — tips
    tipFormat:        'Выделите весь текст (Ctrl+A) → установите Times New Roman, 14 пт, интервал 1,5',
    tipPageNums:      'Вставьте → Номера страниц → Внизу → По центру; включите «Особый колонтитул для первой страницы»',
    tipIntro:         'Расширьте введение: актуальность темы, цель, задачи, объект и предмет исследования, методы',
    tipIntroMissing:  'Добавьте раздел «ВВЕДЕНИЕ» с отдельным заголовком',
    tipConclusion:    'Расширьте заключение: выводы по каждой главе и общий итог исследования',
    tipConcMissing:   'Добавьте раздел «ЗАКЛЮЧЕНИЕ» с выводами по всем главам',
    tipContents:      'Создайте автооглавление: Ссылки → Оглавление (все заголовки через стили Heading 1/2/3)',
    tipChapterSubs:   (n) => `Добавьте минимум 2 подраздела в Главу ${n}: ${n}.1, ${n}.2`,
    tipChapterMiss:   (n) => `Добавьте заголовок «Глава ${n}» или «${n}. Название» (стиль Heading 1)`,
    tipAppendix:      'Добавьте приложения: схемы, таблицы, скриншоты, листинги кода',
    tipTables:        'Добавьте таблицы, рисунки и диаграммы для наглядного анализа результатов',
    tipFindings:      'Завершайте каждую главу выводами, обобщающими результаты',
    tipCitations:     'Подкрепляйте утверждения ссылками на источники в формате [1], [2, 3]',
    tipExcellent:     'Работа на высоком уровне — перед защитой перечитайте введение и заключение ещё раз',
    tipGood:          'Устраните замечания по структуре — это существенно повысит итоговую оценку',
    tipPoor:          'Уделите внимание структуре и анализу результатов — они дают наибольшее количество баллов (65 из 100)',

    // ScoringGuide — descriptions
    descFont: [
      'Основной шрифт — Times New Roman во всём документе',
      'Размер шрифта 14 пт для основного текста',
      'Межстрочный интервал 1,5 во всём тексте',
      'Сквозная нумерация страниц (кроме титульного листа)',
    ],
    descVol: [
      'Общий объём от 45 страниц — полные баллы',
      'Менее 45 страниц — баллы снижаются пропорционально',
      'Введение более 2 страниц (актуальность, цель, задачи, объект, предмет)',
      'Заключение более 2 страниц (выводы по каждой главе)',
    ],
    descStruct: [
      'Оглавление с указанием страниц',
      'Раздел «Введение» как самостоятельный раздел',
      'Глава 1 — минимум 2 подраздела (1.1, 1.2, ...)',
      'Глава 2 — минимум 2 подраздела (2.1, 2.2, ...)',
      'Глава 3 — минимум 2 подраздела (3.1, 3.2, ...)',
      'Раздел «Заключение» как самостоятельный раздел',
      'Раздел «Приложения» в конце работы',
    ],
    descAnalysis: [
      'Таблицы и рисунки — иллюстративный материал анализа',
      'Выводы по каждой главе, обобщающие результаты',
      'Ссылки на источники в тексте в формате [1], [2, 3]',
    ],

    // RequirementsList — card descriptions
    reqDesc: {
      fontTimes:   'Весь основной текст — Times New Roman',
      fontSize:    'Размер шрифта основного текста — 14 пт',
      lineSpacing: 'Межстрочный интервал — 1,5 по всему тексту',
      pageNumbers: 'Сквозная нумерация страниц (титул не нумеруется)',
      volume:      'Общий объём — не менее 45 страниц',
      intro:       'Введение более 2 стр.: актуальность, цель, задачи, объект, предмет',
      conclusion:  'Заключение более 2 стр.: выводы по каждой главе',
      contents:    'Оглавление с перечнем разделов и номерами страниц',
      introSec:    'Раздел «Введение» как самостоятельный раздел',
      ch1:         'Глава 1 — минимум 2 подраздела (1.1, 1.2, ...)',
      ch2:         'Глава 2 — минимум 2 подраздела (2.1, 2.2, ...)',
      ch3:         'Глава 3 — минимум 2 подраздела (3.1, 3.2, ...)',
      conclusionSec: 'Раздел «Заключение» как самостоятельный раздел',
      appendix:    'Раздел «Приложения» в конце работы',
      tablesFigures: 'Иллюстративный материал: таблицы, рисунки, диаграммы',
      findings:    'Выводы по каждой главе, обобщающие результаты',
      citations:   'Ссылки на источники в тексте в формате [1], [2, 3]',
    },

    reqNames: {
      fontTimes: 'Шрифт Times New Roman',
      fontSize: 'Размер шрифта 14 пт',
      lineSpacing: 'Межстрочный интервал 1,5',
      pageNumbers: 'Нумерация страниц',
      volume: 'Общий объём 45–120 стр.',
      intro: 'Введение >2 стр.',
      conclusion: 'Заключение >2 стр.',
      bibliography: 'Список использованных источников (≥20)',
      contents: 'Оглавление',
      introSec: 'Введение',
      ch1: 'Глава 1 (с подразделами ≥2)',
      ch2: 'Глава 2 (с подразделами ≥2)',
      ch3: 'Глава 3 (с подразделами ≥2)',
      ch4: 'Глава 4 (с подразделами ≥2)',
      conclusionSec: 'Заключение',
      appendix: 'Приложения',
      tablesFigures: 'Таблицы и рисунки',
      findings: 'Выводы по главам',
      citations: 'Ссылки на источники',
    },

    // ReportDownloader — PDF-сертификат
    certDownloadBtn: 'Скачать сертификат (PDF)',
    certGenerating: 'Формирование PDF...',
    certBadge: 'Электронный сертификат',
    certTitle: 'Сертификат о проверке',
    certSubtitle: 'дипломной, курсовой или иной учебной работы',
    certWorkName: 'Наименование работы:',
    certCheckDate: 'Дата проверки:',
    certService: 'Сервис проверки:',
    certResultsTitle: 'Результаты проверки по критериям',
    certCriterion: 'Критерий оценивания',
    certEarned: 'Набрано',
    certMax: 'Максимум',
    certRowFormat: '1. Оформление текста (шрифт, размер, интервал, нумерация)',
    certRowVolume: '2. Объём работы (общий, введение, заключение)',
    certRowStructure: '3. Структура и содержание (главы, подразделы, разделы)',
    certRowAnalysis: '4. Экспертный анализ работы (таблицы, выводы, ссылки)',
    certTotalRow: 'ИТОГО',
    certTotalScore: 'ИТОГОВЫЙ БАЛЛ',
    certRemarksTitle: 'Замечания и рекомендации',
    certNoRemarks: 'Существенных замечаний не обнаружено — работа полностью соответствует критериям.',
    certSignatureLine: 'MyEduCheck — сервис проверки учебных работ',
    certScanToVerify: 'Отсканируйте для проверки подлинности',
    certFooter1: 'Документ сформирован сервисом MyEduCheck',
    certFooter2: 'Система проверки дипломных, курсовых и других учебных работ',
    certStamp: { excellent: 'СООТВЕТСТВУЕТ', good: 'ОДОБРЕНО', satisfactory: 'УСЛОВНО', poor: 'НЕ СООТВЕТСТВУЕТ' },
    certFileName: 'Сертификат',
    certUnknownFile: 'Не указано',

    faqTitle: 'Частые вопросы',
    faqSub: 'Ответы на вопросы о проверке дипломных и курсовых работ',
    faq: [
      { q: 'Что такое нормоконтроль и зачем он нужен?', a: 'Нормоконтроль — проверка дипломной или курсовой работы на соответствие формальным требованиям к оформлению: шрифт, интервалы, структура, объём. Это отдельный этап перед защитой, и работу могут не допустить, если требования не соблюдены.' },
      { q: 'Как проверить дипломную работу онлайн бесплатно?', a: 'Загрузите файл в формате DOCX или PDF на главной странице MyEduCheck — проверка запустится автоматически и займёт около 15 секунд. Регистрация не требуется.' },
      { q: 'Какие форматы файлов поддерживаются?', a: 'Поддерживаются DOCX и PDF объёмом до 50 МБ.' },
      { q: 'По каким критериям оценивается работа?', a: 'Четыре категории на 100 баллов: форматирование текста (15), объём работы (20), структура и содержание (50), экспертный анализ — таблицы, выводы, ссылки на источники (15).' },
      { q: 'Проверка действительно бесплатна?', a: 'Да, полностью бесплатна.' },
      { q: 'Можно ли получить сертификат о проверке?', a: 'Да, после проверки доступен PDF-сертификат с результатами и QR-кодом для подтверждения подлинности по ссылке.' },
      { q: 'Проверяет ли сервис на антиплагиат?', a: 'Пока нет — эта функция в разработке. Сейчас MyEduCheck проверяет только оформление, объём, структуру и экспертный анализ.' },
      { q: 'Заменяет ли MyEduCheck официальный нормоконтроль вуза?', a: 'Нет, это независимый вспомогательный инструмент для самопроверки перед официальной сдачей работы, а не замена нормоконтроля вуза.' },
    ],
  },

  uz: {
    brand: 'Bitiruv malakaviy ishlarini baholash tizimi',
    heroTitle: 'Diplom ishini tekshirish',
    heroSub: 'DOCX yoki PDF faylni yuklang — tizim talablarga muvofiqligini avtomatik baholaydi',
    uploadTitle: 'Diplom ishini yuklang',
    uploadDrag: 'Faylni qo\'ying',
    uploadHint: 'PDF yoki DOCX · 50 MB gacha · torting yoki bosing',
    uploadMaxSize: '50 MB gacha',
    uploadedLabel: 'Hujjat yuklandi',
    replace: 'Almashtirish',
    analyzing: 'Ish tahlil qilinmoqda...',
    analyzingStatus: 'Tahlil...',
    ready: 'Tayyor',
    fileTypeError: 'Faqat PDF yoki DOCX',
    loadSteps: ['Fayl yuklanmoqda', 'Formatlash tahlili', 'Tuzilma tekshiruvi', 'Bibliografiya baholash', 'Yakuniy ball hisoblash'],
    progressLabel: 'Tahlil jarayoni',
    totalScore: 'Yakuniy ball',
    compliance: 'Muvofiqlik',
    catFont: 'Formatlash',
    catVol: 'Hajm',
    catStruct: 'Tuzilma',
    catAnalysis: 'Ishning ekspert tahlili',
    catBib: 'Bibliografiya',
    guideTitle: 'BMI baholash mezonlari',
    guideSub: 'Maksimum 100 ball',
    guideFootnote: 'Bonus balllar (4-bob) asosiy 81 balldan tashqari qo\'shiladi',
    infoToggleShow: 'Nima tekshiriladi?',
    infoToggleHide: 'Tavsifni yashirish',
    done: 'Bajarildi',
    partial: 'Qisman',
    notDone: 'Bajarilmadi',
    bonus: 'bonus',
    bonusDone: 'Bonus olindi',
    bonusNone: 'Topilmadi',
    details: 'batafsil',
    grades: ['A\'LO', 'YAXSHI', 'QONIQARLI', 'QONIQARSIZ'],
    step1Label: 'Fayl yuklang',   step1Hint: 'PDF yoki DOCX',
    step2Label: 'Tahlil',         step2Hint: '~15 soniya',
    step3Label: 'Natija',         step3Hint: 'Batafsil hisobot',
    uploadBtn: 'Fayl tanlash', uploadOrDrag: 'yoki bu yerga torting',
    footerLeft:  'Bitiruv ishlarini tekshirish tizimi',
    footerContact: 'Hamkorlik va savollar uchun:',
    footerCitation: 'Platforma ilmiy nashrda tavsiflangan:',
    legalPrivacyBtn: 'Maxfiylik siyosati',
    legalTermsBtn: 'Foydalanish shartlari',
    ptsSuffix: 'b',
    footerCitationLink: 'Alixonov Sh., Xashimov S. — ILMIY TADQIQOTLAR VA ULARNING YECHIMLARI JURNALI, 2026',

    // FeedbackCard
    feedbackTitle: 'Ishning ekspert tahlili',
    feedbackPros: 'Afzalliklar',
    feedbackCons: 'Kamchiliklar',
    feedbackTips: 'Yaxshilash bo\'yicha maslahatlar',
    feedbackNoPros: 'Aniq afzalliklar yo\'q',
    feedbackNoCons: 'Izoh yo\'q — ajoyib natija!',
    scoreExcellent: '— A\'lo daraja. Ish himoyaga tayyor.',
    scoreGood:      '— Yaxshi daraja. Himoyadan oldin izohlarni to\'g\'rilang.',
    scoreFair:      '— Qoniqarli daraja. Qo\'shimcha ishlov talab etiladi.',
    scorePoor:      '— Ko\'pchilik mezonlar bo\'yicha jiddiy ishlov talab etiladi.',

    // FeedbackCard — pros
    proFormatOk:      'Matn rasmiylashtirilishi GOSTga to\'liq mos keladi: Times New Roman 14 pt, interval 1,5',
    proPageNums:      'Sahifalar raqamlash to\'g\'ri amalga oshirilgan',
    proVolOk:         (p) => `Ish hajmi ${p} bet — talablarga mos (≥45 bet)`,
    proIntroOk:       'Kirish to\'liq — 2 betdan ortiq',
    proConclusionOk:  'Xulosa to\'liq — 2 betdan ortiq',
    proContentsOk:    'Sahifalar raqamlangan mundarija mavjud',
    proChaptersOk:    'Barcha uch bob to\'g\'ri tuzilgan (har birida ≥2 bo\'lim)',
    proConcSecOk:     '«Xulosa» bo\'limi alohida sarlavha sifatida ajratilgan',
    proAppendixOk:    'Ilovalar ishga kiritilgan',
    proTablesOk:      'Tahlil jadvallar va rasmlar bilan ta\'minlangan',
    proFindingsOk:    'Ishda boblar bo\'yicha xulosalar mavjud',
    proCitationsOk:   'Matn manbalarga havolalar bilan ta\'minlangan',

    // FeedbackCard — cons
    conFontTimes:     'Shrift talablarga mos emas (Times New Roman talab etiladi)',
    conFontSize:      'Shrift o\'lchami 14 pt emas',
    conLineSpacing:   'Satrlar oralig\'i 1,5 emas',
    conPageNums:      'Sahifalar raqamlash topilmadi',
    conVolLow:        (p) => `Ish hajmi ${p} bet — yetarli emas (≥45 bet talab etiladi)`,
    conIntroShort:    'Kirish qisqa (2 betdan ortiq talab etiladi)',
    conIntroMissing:  '«KIRISH» bo\'limi topilmadi',
    conConcShort:     'Xulosa qisqa (2 betdan ortiq talab etiladi)',
    conConcMissing:   '«XULOSA» bo\'limi topilmadi',
    conContents:      'Mundarija topilmadi',
    conChapterSubs:   (n) => `${n}-bob 2 ta bo\'limdan kam`,
    conChapterMiss:   (n) => `${n}-bob hujjatda topilmadi`,
    conAppendix:      '«Ilovalar» bo\'limi yo\'q',
    conTables:        'Yetarli ko\'rgazmali material yo\'q (jadvallar, rasmlar)',
    conFindings:      'Boblar bo\'yicha xulosalar topilmadi',
    conCitations:     'Matnda manbalarga havolalar kam',

    // FeedbackCard — tips
    tipFormat:        'Barcha matnni belgilang (Ctrl+A) → Times New Roman, 14 pt, interval 1,5 o\'rnating',
    tipPageNums:      'Qo\'shish → Sahifa raqamlari → Pastda → Markazda; «Birinchi sahifa uchun maxsus kolontitul»ni yoqing',
    tipIntro:         'Kirishni kengaytiring: mavzuning dolzarbligi, maqsad, vazifalar, ob\'ekt va predmet, metodlar',
    tipIntroMissing:  'Alohida sarlavha bilan «KIRISH» bo\'limini qo\'shing',
    tipConclusion:    'Xulosani kengaytiring: har bob bo\'yicha xulosalar va umumiy natija',
    tipConcMissing:   'Barcha boblar bo\'yicha xulosalar bilan «XULOSA» bo\'limini qo\'shing',
    tipContents:      'Avto-mundarija yarating: Havolalar → Mundarija (Heading 1/2/3 stillari orqali)',
    tipChapterSubs:   (n) => `${n}-bobga kamida 2 ta bo\'lim qo\'shing: ${n}.1, ${n}.2`,
    tipChapterMiss:   (n) => `«${n}-bob» yoki «${n}. Nomi» sarlavhasini qo\'shing (Heading 1 stili)`,
    tipAppendix:      'Ilovalar qo\'shing: sxemalar, jadvallar, skrinshotlar, kod ro\'yxatlari',
    tipTables:        'Natijalar tahlili uchun jadvallar, rasmlar va diagrammalar qo\'shing',
    tipFindings:      'Har bir bobni natijalarni umumlashtiradigan xulosalar bilan yakunlang',
    tipCitations:     'Fikrlarni [1], [2, 3] formatidagi manba havolalari bilan mustahkamlang',
    tipExcellent:     'Ish yuqori darajada — himoyadan oldin kirish va xulosani yana bir bor o\'qing',
    tipGood:          'Tuzilmadagi izohlarni bartaraf eting — bu yakuniy bahoni sezilarli darajada oshiradi',
    tipPoor:          'Tuzilma va natijalar tahliliga e\'tibor bering — ular eng ko\'p ball beradi (65/100)',

    // ScoringGuide — descriptions
    descFont: [
      'Asosiy shrift — hujjat bo\'ylab Times New Roman',
      'Asosiy matn uchun shrift o\'lchami 14 pt',
      'Butun matn bo\'ylab satrlar oralig\'i 1,5',
      'Sahifalarni ketma-ket raqamlash (sarlavha sahifasidan tashqari)',
    ],
    descVol: [
      'Umumiy hajm 45 betdan — to\'liq ball',
      '45 betdan kam — ball proporsional ravishda kamayadi',
      'Kirish 2 betdan ortiq (dolzarblik, maqsad, vazifalar, ob\'ekt, predmet)',
      'Xulosa 2 betdan ortiq (har bob bo\'yicha xulosalar)',
    ],
    descStruct: [
      'Sahifalar ko\'rsatilgan mundarija',
      'Mustaqil bo\'lim sifatida «Kirish»',
      '1-bob — kamida 2 ta bo\'lim (1.1, 1.2, ...)',
      '2-bob — kamida 2 ta bo\'lim (2.1, 2.2, ...)',
      '3-bob — kamida 2 ta bo\'lim (3.1, 3.2, ...)',
      'Mustaqil bo\'lim sifatida «Xulosa»',
      'Ish oxirida «Ilovalar» bo\'limi',
    ],
    descAnalysis: [
      'Jadvallar va rasmlar — tahlilning ko\'rgazmali materiallari',
      'Har bir bobning natijalarini umumlashtiruvchi xulosalar',
      'Matnda [1], [2, 3] formatidagi manba havolalari',
    ],

    // RequirementsList — card descriptions
    reqDesc: {
      fontTimes:   'Barcha asosiy matn — Times New Roman',
      fontSize:    'Asosiy matn shrift o\'lchami — 14 pt',
      lineSpacing: 'Satrlar oralig\'i — butun matn bo\'ylab 1,5',
      pageNumbers: 'Sahifalarni ketma-ket raqamlash (sarlavha raqamlanmaydi)',
      volume:      'Umumiy hajm — kamida 45 bet',
      intro:       'Kirish 2 betdan ortiq: dolzarblik, maqsad, vazifalar, ob\'ekt, predmet',
      conclusion:  'Xulosa 2 betdan ortiq: har bob bo\'yicha xulosalar',
      contents:    'Bo\'limlar ro\'yxati va sahifa raqamlari bilan mundarija',
      introSec:    'Mustaqil bo\'lim sifatida «Kirish»',
      ch1:         '1-bob — kamida 2 ta bo\'lim (1.1, 1.2, ...)',
      ch2:         '2-bob — kamida 2 ta bo\'lim (2.1, 2.2, ...)',
      ch3:         '3-bob — kamida 2 ta bo\'lim (3.1, 3.2, ...)',
      conclusionSec: 'Mustaqil bo\'lim sifatida «Xulosa»',
      appendix:    'Ish oxirida «Ilovalar» bo\'limi',
      tablesFigures: 'Ko\'rgazmali material: jadvallar, rasmlar, diagrammalar',
      findings:    'Har bir bobning natijalarini umumlashtiruvchi xulosalar',
      citations:   'Matnda [1], [2, 3] formatidagi manba havolalari',
    },

    reqNames: {
      fontTimes: 'Times New Roman shrifti',
      fontSize: 'Shrift o\'lchami 14 pt',
      lineSpacing: 'Satrlar oralig\'i 1,5',
      pageNumbers: 'Sahifalar raqamlash',
      volume: 'Umumiy hajm 45–120 bet',
      intro: 'Kirish >2 bet',
      conclusion: 'Xulosa >2 bet',
      bibliography: 'Foydalanilgan adabiyotlar ro\'yxati (≥20)',
      contents: 'Mundarija',
      introSec: 'Kirish',
      ch1: '1-bob (≥2 bo\'lim bilan)',
      ch2: '2-bob (≥2 bo\'lim bilan)',
      ch3: '3-bob (≥2 bo\'lim bilan)',
      ch4: '4-bob (≥2 bo\'lim bilan)',
      conclusionSec: 'Xulosa',
      appendix: 'Ilovalar',
      tablesFigures: 'Jadval va rasmlar',
      findings: 'Boblar bo\'yicha xulosalar',
      citations: 'Manbalarga havolalar',
    },

    // ReportDownloader — PDF-sertifikat
    certDownloadBtn: 'Sertifikatni yuklab olish (PDF)',
    certGenerating: 'PDF tayyorlanmoqda...',
    certBadge: 'Elektron sertifikat',
    certTitle: 'Tekshiruv sertifikati',
    certSubtitle: 'diplom, kurs yoki boshqa o\'quv ishi',
    certWorkName: 'Ish nomi:',
    certCheckDate: 'Tekshiruv sanasi:',
    certService: 'Tekshiruv xizmati:',
    certResultsTitle: 'Mezonlar bo\'yicha natijalar',
    certCriterion: 'Baholash mezoni',
    certEarned: 'To\'plangan',
    certMax: 'Maksimum',
    certRowFormat: '1. Matn rasmiylashtirilishi (shrift, o\'lcham, interval, raqamlash)',
    certRowVolume: '2. Ish hajmi (umumiy, kirish, xulosa)',
    certRowStructure: '3. Tuzilma va mazmun (boblar, bo\'limlar, qismlar)',
    certRowAnalysis: '4. Ishning ekspert tahlili (jadvallar, xulosalar, havolalar)',
    certTotalRow: 'JAMI',
    certTotalScore: 'YAKUNIY BALL',
    certRemarksTitle: 'Eslatmalar va tavsiyalar',
    certNoRemarks: 'Jiddiy eslatmalar aniqlanmadi — ish barcha mezonlarga to\'liq mos keladi.',
    certSignatureLine: 'MyEduCheck — o\'quv ishlarini tekshirish xizmati',
    certScanToVerify: 'Haqiqiyligini tekshirish uchun skanerlang',
    certFooter1: 'Hujjat MyEduCheck xizmati tomonidan shakllantirildi',
    certFooter2: 'Diplom, kurs va boshqa o\'quv ishlarini tekshirish tizimi',
    certStamp: { excellent: 'MOS KELADI', good: 'MA\'QULLANDI', satisfactory: 'SHARTLI', poor: 'MOS KELMAYDI' },
    certFileName: 'Sertifikat',
    certUnknownFile: 'Ko\'rsatilmagan',

    faqTitle: 'Tez-tez so\'raladigan savollar',
    faqSub: 'Diplom va kurs ishlarini tekshirish haqida savollarga javoblar',
    faq: [
      { q: 'Normokontrol nima va nima uchun kerak?', a: 'Normokontrol — diplom yoki kurs ishining rasmiylashtirish talablariga muvofiqligini tekshirish: shrift, intervallar, tuzilma, hajm. Bu himoyadan oldingi alohida bosqich, talablar bajarilmasa ish himoyaga qo\'yilmasligi mumkin.' },
      { q: 'Diplom ishini onlayn bepul qanday tekshirish mumkin?', a: 'MyEduCheck bosh sahifasida DOCX yoki PDF formatidagi faylni yuklang — tekshiruv avtomatik boshlanadi va taxminan 15 soniya davom etadi. Ro\'yxatdan o\'tish shart emas.' },
      { q: 'Qanday fayl formatlari qo\'llab-quvvatlanadi?', a: 'DOCX va PDF, hajmi 50 MB gacha.' },
      { q: 'Ish qanday mezonlar bo\'yicha baholanadi?', a: '100 ballik to\'rtta toifa: matn rasmiylashtirilishi (15), ish hajmi (20), tuzilma va mazmun (50), ekspert tahlili — jadvallar, xulosalar, manbalarga havolalar (15).' },
      { q: 'Tekshiruv rostdan ham bepulmi?', a: 'Ha, to\'liq bepul.' },
      { q: 'Tekshiruv haqida sertifikat olish mumkinmi?', a: 'Ha, tekshiruvdan so\'ng natijalar va haqiqiyligini havola orqali tasdiqlash uchun QR-kodli PDF-sertifikat mavjud.' },
      { q: 'Xizmat antiplagiatni tekshiradimi?', a: 'Hozircha yo\'q — bu funksiya ishlab chiqilmoqda. Hozir MyEduCheck faqat rasmiylashtirish, hajm, tuzilma va ekspert tahlilini tekshiradi.' },
      { q: 'MyEduCheck OTMning rasmiy normokontrolini almashtiradimi?', a: 'Yo\'q, bu rasmiy topshirishdan oldin o\'z-o\'zini tekshirish uchun mustaqil yordamchi vosita, OTM normokontrolining o\'rnini bosmaydi.' },
    ],
  },
};

export function AppProvider({ children }) {
  const [dark, setDark] = useState(() => localStorage.getItem('theme') === 'dark');
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'ru');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const t = LANGS[lang];

  return (
    <Ctx.Provider value={{ dark, setDark, lang, setLang, t }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
